import { post } from './axios';
import { DeviceDetectionRes } from './interface/common';

export interface ContentData<T> {
  content: T;
}

// 上报用户设置检测结果 仅在成功的时候才上报
export const createDeviceDetect = (data: Record<string, unknown>) => {
  return post(
    `${process.env.NEXT_PUBLIC_WK_GATEWAY_API_DOMAIN}/ms-user/api/user/device/create`,
    data,
  );
};

// 获取用户设备检测结果列表
export const getDeviceDetect = (data: { studentCode: string }) => {
  return post<DeviceDetectionRes[], DeviceDetectionRes[]>(
    `${process.env.NEXT_PUBLIC_WK_GATEWAY_API_DOMAIN}/ms-user/api/user/device/list`,
    data,
  );
};

// 更新版本状态
export const updateVersionState = (data: any) => {
  return post<any, any>(`/api/student/web/event/update`, data);
};
